<template>
  <v-card style="width: 100%; height: 100%;">
    <v-container fluid grid-list-md fill-height style="padding-top: 8px;">
      <v-layout row style="width: 100%; height: 100%">
        <v-flex d-flex md12>
          <v-layout column>
            <v-flex
                d-flex md1
                style="height: 3rem; max-height: 3rem; align-items: center; justify-content: end;"
            >
              <ul
                  style="
                    background-color: rgb(51,82,128);
                    border-radius:8px;
                    color: white;
                    display: inline-flex;
                    margin: 0;
                    padding: 2px 16px 2px 0px ;
                    width: fit-content;
                    max-width: fit-content;
                    list-style: none;
                  "
              >
                <li
                    v-for="(item, index) in status_items"
                    :key="index"
                    style="display: inline-flex;"
                >
                  <ColorRadioV2
                      :id="''"
                      :selected="item.value"
                      :items="status_items"
                      :callback="null"
                      :offset_left="'0px'"
                      :noChange="true"
                      style="padding-top: 2px"
                  />
                  <span style="padding-left: 0px">{{ item.label }}</span>
                </li>
              </ul>
              <LogButton
                  style="
                    max-width: 28px;
                    max-height: 3rem;
                    color:white;
                    background-color: rgb(51,82,128);
                    border-radius: 8px;
                    margin-left: 16px;
                  "
                  :file="'maintenance_tasks'"
                  :output="'maintenance-tasks'"
                  :logsTitle="'Maintenance Tasks'"
                  :notification_table="'maintenance_tasks'"
                  :vessels="vesselsWithTasks"
              />
              <SettingsButton
                  style="
                    max-width: 28px;
                    max-height: 3rem;
                    color:white;
                    background-color: rgb(51,82,128);
                    border-radius: 8px;
                    margin-left: 16px;
                  "
                  :vessels="vesselsWithTasks"
              />
            </v-flex>
            <v-flex id="maintenance_tasks_table" d-flex md12>
              <dx-data-grid
                  class="grid collapsable"
                  :style="`width: 100%; height: 100%; max-height:${tableHeight};`"
                  :data-source="vesselsDataSource"
                  :remote-operations="false"
                  :show-column-lines="true"
                  :show-row-lines="true"
                  :show-borders="true"
                  :word-wrap-enabled="true"
                  :row-alternation-enabled="false"
                  :column-auto-width="true"
                  @selection-changed="vesselSelected"
                  @content-ready="contentReady"
                  @editor-preparing="overrideOnValueChanged"
              >
                <DxSelection mode="single"/>
                <DxHeaderFilter :visible="false"/>
                <DxFilterRow :visible="true"/>
                <DxLoadPanel :enabled="false"/>
                <DxPaging :page-size="10"/>
                <dx-column
                    :filter-operations="['contains']"
                    alignment="center"
                    data-field="vessel"
                    caption="Vessel"
                />
                <dx-column
                    :filter-operations="['contains']"
                    alignment="center"
                    data-field="imo"
                    caption="Imo"
                />

                <DxMasterDetail
                    :enabled="false"
                    template="engineTemplate"
                />

                <template #engineTemplate="{}">
                  <div style="position: relative; width: calc(100% - 16px); left: 0px;">
                    <dx-data-grid
                        class="grid collapsable"
                        :ref="'enginesGrid'"
                        :style="`width: 100%; height: 100%; max-height:800px;`"
                        :data-source="engineDataSource"
                        :remote-operations="false"
                        :show-column-lines="true"
                        :show-row-lines="true"
                        :show-borders="true"
                        :word-wrap-enabled="true"
                        :row-alternation-enabled="false"
                        :column-auto-width="true"
                        @selection-changed="engineSelected"
                        @content-ready="contentReady"
                        @editor-preparing="overrideOnValueChanged"
                    >
                      <DxSelection mode="single"/>
                      <DxHeaderFilter :visible="false"/>
                      <DxFilterRow :visible="true"/>
                      <DxLoadPanel :enabled="false"/>
                      <DxPaging :page-size="5"/>
                      <dx-column
                          :filter-operations="['contains']"
                          alignment="center"
                          data-field="engine"
                          caption="Engine"
                      />

                      <DxMasterDetail
                          :enabled="false"
                          template="componentTemplate"
                      />

                      <template #componentTemplate="{}">
                        <div style="position: relative; width: calc(100% - 16px); left: 0px;">
                          <dx-data-grid
                              class="grid collapsable"
                              :ref="'componentsGrid'"
                              :style="`width: 100%; height: 100%; max-height:700px;`"
                              :data-source="componentDataSource"
                              :remote-operations="false"
                              :show-column-lines="true"
                              :show-row-lines="true"
                              :show-borders="true"
                              :word-wrap-enabled="true"
                              :row-alternation-enabled="false"
                              :column-auto-width="true"
                              @selection-changed="componentSelected"
                              @content-ready="contentReady"
                              @editor-preparing="overrideOnValueChanged"
                          >
                            <DxSelection mode="single"/>
                            <DxHeaderFilter :visible="false"/>
                            <DxFilterRow :visible="true"/>
                            <DxLoadPanel :enabled="false"/>
                            <DxPaging :page-size="5"/>
                            <dx-column
                                :filter-operations="['contains']"
                                alignment="center"
                                data-field="component"
                                caption="Component"
                            />

                            <DxMasterDetail
                                :enabled="false"
                                template="taskTemplate"
                            />

                            <template #taskTemplate="{}">
                              <div style="position: relative; width: calc(100% - 16px); left: 0px;">
                                <ComponentTasksTable
                                    :ref="'componentTasksTable'"
                                    :tasksDataSource="tasksDataSource"
                                    :taskSelected="taskSelected"
                                    :contentReady="contentReady"
                                    :overrideOnValueChanged="overrideOnValueChanged"
                                    :createChartForSelectedRow="createChartForSelectedRow"
                                    :maximizeRHGraph="maximizeRHGraph"
                                    :selectStatus="selectStatus"
                                    :selectedTaskRow="selectedTaskRow"
                                    :tasks.sync="updates"
                                />
                              </div>
                            </template>
                          </dx-data-grid>
                        </div>
                      </template>
                    </dx-data-grid>
                  </div>
                </template>
              </dx-data-grid>
            </v-flex>
            <v-flex d-flex md1>
              <v-layout row>
                <v-flex d-flex md1 style="padding-left: 0; text-align: right">
                  <v-btn
                      :disabled="disable_save"
                      style="color:white; background-color: rgb(51,82,128);"
                      @click="openConfirmDialog"
                  >
                    Save
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-dialog v-model="showUpdatesDialog" width="1420" height="640">
        <v-card style="width:100%;height:100%;">
          <v-card-title primary class="title" style="height:10%;">Tasks</v-card-title>
          <v-card-media style="height:80%; max-height:80%; overflow-y:auto; padding: 0 16px; width: calc(100% - 0)" >
            <v-layout column>
              <v-flex d-flex md8>
                <dx-data-grid
                    class="grid collapsable"
                    :style="`width: 100%; height: 100%; max-height:${tableHeight}`"
                    :data-source="tasksUpdateDataSource"
                    :remote-operations="true"
                    :show-column-lines="true"
                    :show-row-lines="true"
                    :show-borders="true"
                    :word-wrap-enabled="true"
                    :row-alternation-enabled="false"
                    :column-auto-width="true"
                >
                  <DxPaging :page-size="10"/>
                  <DxHeaderFilter :visible="false"/>
                  <DxFilterRow :visible="false"/>
                  <dx-column
                      :filter-operations="['contains']"
                      alignment="center"
                      data-field="vessel"
                      caption="Vessel"
                  />
                  <dx-column
                      :filter-operations="['contains']"
                      alignment="center"
                      data-field="component"
                      caption="Component"
                  />
                  <dx-column
                      :filter-operations="['contains']"
                      alignment="center"
                      data-field="c_rh"
                      caption="Current RH"
                  />
                  <dx-column
                      :filter-operations="['contains']"
                      alignment="center"
                      data-field="action"
                      caption="M. Action"
                  />

                  <dx-column
                      :filter-operations="['contains']"
                      alignment="center"
                      data-field="pl_rh"
                      caption="Planned RH"
                  />

                  <dx-column
                      :filter-operations="['contains']"
                      alignment="center"
                      data-field="pr_rh"
                      caption="Predicted RH"
                  />
                  <dx-column
                      :filter-operations="['contains']"
                      alignment="center"
                      data-field="com_rh"
                      caption="Completion RH"
                  />
                  <dx-column
                      :allowHeaderFiltering="false"
                      :allowFiltering="false"
                      :filter-operations="[]"
                      alignment="center"
                      data-field="verified"
                      data-type="boolean"
                      caption="Status"
                      cell-template="verifiedTemp"
                      :minWidth="'150px'"
                      :width="'150px'"
                      :maxWidth="'150px'"
                      :allowSorting="false"
                  />
                  <div slot="verifiedTemp" slot-scope="{data}">
                    <ColorRadioV2
                        :id="data.row.data.id"
                        :selected="data.row.data.acknowledged"
                        :items="status_items"
                        :noChange="true"
                    />
                  </div>
                </dx-data-grid>
              </v-flex>
              <v-flex d-flex md4 style="padding-top: 16px;">
                <v-layout column>
                  <v-flex d-flex md6>
                    <v-text-field v-model="username" label="Username" />
                  </v-flex>
                  <v-flex d-flex md6>
                    <v-textarea v-model="comment" label="Comment" />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-media>
          <v-card-actions style="height:10%;">
            <v-spacer/>
            <v-btn color="primary" flat @click="cancelConfirmDialog">Cancel</v-btn>
            <v-btn style="color:white; background-color: rgb(51,82,128);" @click="submitUpdates">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <TaskDetails :ref="'detailedChart'" />
    </v-container>
  </v-card>
</template>

<script>
import Chart from '../components/Chart'
import {DxColumn, DxDataGrid, DxFilterRow, DxHeaderFilter, DxLoadPanel, DxMasterDetail, DxPaging, DxSelection} from "devextreme-vue/data-grid";
import ColorRadioV2 from "@/components/ColorRadioV2";
import LogButton from "@/components/LogButton";
import {createStore} from "devextreme-aspnet-data-nojquery";
import {store} from "@/main";
import axios from "axios";
import ComponentTasksTable from '@/components/cbm/ComponentTasksTable';
import TaskDetails from '@/components/cbm/TaskDetails';
import SettingsButton from '@/components/cbm/SettingsButton';

export default {
  name: "MaintenanceTasks",
  components: {
    Chart,
    DxDataGrid,
    DxLoadPanel,
    DxColumn,
    DxPaging,
    DxFilterRow,
    DxHeaderFilter,
    DxMasterDetail,
    DxSelection,
    ColorRadioV2,
    LogButton,
    ComponentTasksTable,
    TaskDetails,
    SettingsButton
  },
  data() {
    return {
      tableHeight: '0px',
      vesselsDataSource: null,
      engineDataSource: null,
      componentDataSource: null,
      tasksDataSource: null,
      tasksUpdateDataSource: null,
      selectedVesselRow: {},
      selectedEngineRow: {},
      selectedComponentRow: {},
      selectedTaskRow: {},
      showUpdatesDialog: false,
      status_items: [
        {
          'value': -1,
          'color': 'white',
          'label': 'Pending'
        },
        {
          'value': 0,
          'color': 'red',
          'label': 'Rejected'
        },
        {
          'value': 1,
          'color': 'green',
          'label': 'Approved'
        }
      ],
      updates: {},
      hasUpdates: false,
      username: '',
      comment: '',
      chartData: {},
      selectedTaskChart: {
        chart: {
          height: 0,
        },
        exporting: {
          enabled: false
        },
        title: {
          text: ''
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false
            },
          }
        },
        series: [
          {
            name: "Standard running hours",
            animation: false,
            data: [],
            size: '100%',
            innerSize: '70%',
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          },
          {
            name: "Usage-based running hours",
            animation: false,
            data: [],
            size: '100%',
            innerSize: '70%',
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          },
          {
            name: "Planned interval",
            animation: false,
            data: [],
            size: '100%',
            innerSize: '70%',
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          }
        ],
        xAxis: {
          type: 'datetime',
          title: {
            text: 'Time',
            align: 'high'
          },
          crosshair: true
        },
        yAxis: {
          title: {
            text: 'Running Hours',
            align: 'high'
          }
        },
        tooltip: {
          shared: true,
        },
        credits: {enabled: false}
      },
      rhGraphModal: false,
      maximizeChartData: {},
      maximizeDetailedChartData: {},
      collapsingTask: false,
      vesselsWithTasks: [],
      disable_save: true
    }
  },
  methods: {
    getPeriod() {
      let period;

      switch (store.type) {
        case 'month':
          period = '1month'
          break;
        case 'threemonths':
          period = '3months'
          break;
        case 'sixmonths':
          period = '6months'
          break;
        case 'twelvemonths':
          period = '12months'
          break;
      }

      return period;
    },
    setVesselsDataSource: function () {
      let period = this.getPeriod(),
          params = {
            'statuses': JSON.stringify(this.updates),
            'aggregate': 1
          };

      if (typeof period == 'undefined') {
        return;
      }

      this.vesselsDataSource = createStore({
        loadUrl: `${store.config.api_location}/maintenance/tasks/experts/period/${period}`,
        loadMethod: "POST",
        loadParams: params,
        onLoading: (options) => {
          store.loading = false;
        },
        onLoaded: (data) => {
          store.loading = false;
        },
        onAjaxError: (e) => {
          store.loading = false;
        }
      });
    },
    setEngineDataSource: function (vessel) {
      let period = this.getPeriod(),
          params = {
            'statuses': JSON.stringify(this.updates),
            'imo': vessel.imo,
            'aggregate': 1
          };

      if (typeof period == 'undefined') {
        return;
      }

      this.engineDataSource = createStore({
        loadUrl: `${store.config.api_location}/maintenance/tasks/experts/period/${period}`,
        loadMethod: "POST",
        loadParams: params,
        onLoading: (options) => {
          store.loading = false;
        },
        onLoaded: (data) => {
          store.loading = false;
        },
        onAjaxError: (e) => {
          store.loading = false;
        }
      });
    },
    setComponentDataSource: function (engine) {
      let period = this.getPeriod(),
          params = {
            'statuses': JSON.stringify(this.updates),
            'imo': engine.imo,
            'engine': engine.engine,
            'aggregate': 1
          };

      if (typeof period == 'undefined') {
        return;
      }

      this.componentDataSource = createStore({
        loadUrl: `${store.config.api_location}/maintenance/tasks/experts/period/${period}`,
        loadMethod: "POST",
        loadParams: params,
        onLoading: (options) => {
          store.loading = false;
        },
        onLoaded: (data) => {
          store.loading = false;
        },
        onAjaxError: (e) => {
          store.loading = false;
        }
      });
    },
    setTasksDataSource: function (component) {
      let period = this.getPeriod(),
          params = {
            'statuses': JSON.stringify(this.updates),
            'imo': component.imo,
            'engine': component.engine,
            'component': component.component
          };

      if (typeof period == 'undefined') {
        return;
      }

      this.tasksDataSource = createStore({
        loadUrl: `${store.config.api_location}/maintenance/tasks/experts/period/${period}`,
        loadMethod: "POST",
        loadParams: params,
        onLoading: (options) => {
          store.loading = false;
        },
        onLoaded: (data) => {
          store.loading = false;
        },
        onAjaxError: (e) => {
          store.loading = false;
        }
      });
    },
    setTasksUpdateDataSource: function () {
      let period = this.getPeriod(),
          params = {
            'ids': JSON.stringify(Object.keys(this.updates)),
            'statuses': JSON.stringify(this.updates)
          };

      if (typeof period == 'undefined') {
        return;
      }

      this.tasksUpdateDataSource = createStore({
        loadUrl: `${store.config.api_location}/maintenance/tasks/experts/period/${period}/byId`,
        loadMethod: "POST",
        loadParams: params,
        onLoading: (options) => {
          store.loading = true;
        },
        onLoaded: (data) => {
          this.showUpdatesDialog = true
          store.loading = false;
        },
        onAjaxError: (e) => {
          store.loading = false;
        }
      });
    },
    vesselSelected: function (e) {
      e.component.collapseAll(-1);
      this.selectedVesselRow = e.currentSelectedRowKeys[0];

      e.component.expandRow(this.selectedVesselRow);
      this.setEngineDataSource(this.selectedVesselRow);
    },
    engineSelected: function (e) {
      e.component.collapseAll(-1);
      this.selectedEngineRow = e.currentSelectedRowKeys[0];

      if (!!this.selectedEngineRow) {
        e.component.expandRow(this.selectedEngineRow);
        this.setComponentDataSource(this.selectedEngineRow);
      }
    },
    componentSelected: function (e) {
      e.component.collapseAll(-1);
      this.selectedComponentRow = e.currentSelectedRowKeys[0];

      if (!!this.selectedComponentRow) {
        e.component.expandRow(this.selectedComponentRow);
        this.setTasksDataSource(this.selectedComponentRow);
      }
    },
    taskSelected: function (e) {
      e.component.collapseAll(-1);
      this.selectedTaskRow = e.currentSelectedRowKeys[0];

      e.component.expandRow(this.selectedTaskRow);
    },
    contentReady: function (e) {
      let selected = e.component.getSelectedRowKeys(),
          lookup = e.component.getVisibleRows().filter((row) => {
            return row.data == selected[0]
          });

      if (!e.component.getSelectedRowKeys().length || !lookup.length) {
        e.component.selectRowsByIndexes(0);
      }
    },
    overrideOnValueChanged: function (e) {
      if (e.parentType == 'filterRow') {
        e.editorOptions.placeholder = `Filter: ${e.caption}`;
      }
    },
    createChartForSelectedRow: function () {
      let chart = JSON.parse(JSON.stringify(this.selectedTaskChart))
      chart.series[0].data = this.selectedTaskRow.events.calculated.values
      chart.series[1].data = this.selectedTaskRow.events.predicted.values
      chart.series[2].data = this.selectedTaskRow.events.overhaul_threshold.values

      return chart;
    },
    maximizeRHGraph(data) {
      this.$refs['detailedChart'].setModalActive(true);

      let series = JSON.parse(JSON.stringify(data.series));

      for (var i in series) {
        if (series.hasOwnProperty(i)) {
          series[i].yAxis = 1;
        }
      }

      let maximizeChartData = JSON.parse(JSON.stringify(data))
      maximizeChartData['title'] = {
        text: '',
        align: 'right',
        x: -10
      }
      this.$refs['detailedChart'].setTask(this.selectedTaskRow);

      setTimeout(() => {
        maximizeChartData['chart']['zoomType'] = 'xy';
        maximizeChartData['chart']['width'] = 1420 * 0.95
        maximizeChartData['chart']['height'] = 1024 * 0.6

        this.$refs['detailedChart'].setChartData(maximizeChartData);

        this.maximizeDetailedChartData['chart']['zoomType'] = 'xy';
        this.maximizeDetailedChartData['chart']['width'] = 1420 * 0.95
        this.maximizeDetailedChartData['chart']['height'] = 1024 * 0.6

        this.$refs['detailedChart'].setChartDataDetailed(this.maximizeDetailedChartData);
      }, 300)
    },
    openConfirmDialog: function () {
      this.setTasksUpdateDataSource()
    },
    cancelConfirmDialog: function () {
      this.username = '';
      this.comment = '';
      this.showUpdatesDialog = false;
    },
    submitUpdates: function () {
      if (this.username.length < 1 || this.comment.length < 1) {
        return;
      }

      let data = {
        tasks: Object.keys(this.updates).map((taskId => {
          let task = this.updates[taskId];

          return {
            id: taskId,
            acknowledged: task
          }
        })),
        comment: this.comment,
        username: this.username
      }

      store.loading = true;
      axios
          .post(store.config.api_location + '/maintenance/tasks/update', data, {headers: {Authorization: store.userProfile.jwt}})
          .then((res) => {

          })
          .catch((e) => {
          })
          .finally(() => {
            store.loading = false;
          });
    },
    setTableHeight() {
      let height = (window.outerHeight / 12 * 8).toFixed(0);
      this.tableHeight = height + 'px !important';
    },
    getVesselsWithTasks() {
      axios.get(`${store.config.api_location}/maintenance/tasks/vessels`).then((res) => {
        this.vesselsWithTasks = res.data.data.names;
      });
    }
  },
  mounted() {
    this.chartData = {
      'kpis': {
        chart: {
          height: 0,
        },
        exporting: {
          enabled: false
        },
        title: {
          text: undefined
        },
        plotOptions: {
          pie: {
            shadow: false,
            center: ['50%', '50%'],
            dataLabels: {
              enabled: true,
              formatter: function () {
                return `${this.point.name}: ${this.point.y}%`
              }
            }
          }
        },
        series: [{
          type: 'pie',
          animation: false,
          data: [
            {
              'name': 'KPI 1',
              'y': 25
            },
            {
              'name': 'KPI 2',
              'y': 12.5
            },
            {
              'name': 'KPI 3',
              'y': 12.5
            },
            {
              'name': 'KPI 4',
              'y': 25
            },
            {
              'name': 'KPI 5',
              'y': 25
            }
          ],
          size: '100%',
          states: {
            hover: {
              enabled: false
            },
            normal: {
              animation: false
            },
            inactive: {
              opacity: 1
            }
          }
        }],
        tooltip: {
          formatter: function () {
            return this.point.name + ': ' + this.point.y.toFixed(1);
          }
        },
        credits: {enabled: false}
      }
    }

    this.maximizeDetailedChartData = {
      chart: {
        height: 0,
      },
      exporting: {
        enabled: false
      },
      title: {
        text: undefined
      },
      plotOptions: {
        series: {
          label: {
            connectorAllowed: false
          },
        }
      },
      series: [],
      xAxis: {
        type: 'datetime',
        title: {
          text: 'Time',
          align: 'high'
        },
        crosshair: true
      },
      yAxis: [
        {
          title: {
            text: 'Running Hours',
            align: 'high'
          },
          height: '45%'
        },
        {
          title: {
            text: 'Running Hours',
            align: 'high'
          },
          top: '55%',
          height: '45%',
          offset: 0
        }
      ],
      tooltip: {
        shared: true,
      },
      credits: {enabled: false}
    };

    this.setTableHeight();
  },
  computed: {
    period: function () {
      return store.type;
    },
    api_location: function () {
      return typeof store.config.api_location != 'undefined';
    },
    // disable_save: function () {
    //   return Object.keys(this.updates).length > 0
    // }
  },
  watch: {
    period: function () {
      this.setVesselsDataSource();
    },
    updates: {
      handler: function () {
        console.log(888)
        this.setTasksDataSource(this.selectedComponentRow);
        new Promise((res) => {
          this.disable_save = Object.keys(this.updates).length < 1
          res();
        })
      },
      deep: true,
      immediate: true
    },
    api_location: {
      handler: function () {
        if (typeof store.config.api_location != 'undefined') {
          this.getVesselsWithTasks();
          this.setVesselsDataSource();
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style>
#maintenance_tasks_table .dx-master-detail-cell {
  padding: 0 !important;
}

.align_bottom[role="columnheader"] .dx-datagrid-text-content {
  padding-top: 2em;
}

#rhModalTabs .v-tabs__item.activeTab {
  border-bottom: 2px solid rgb(144, 170, 218);
}
</style>